<template>
  <p class="active-cost--ticket">
    <span class="active-cost--now">
      <i
        class="icon-ticket"
        :style="{
          backgroundImage: gameCoinIcon ? 'url(' + gameCoinIcon + ')' : '',
          display: goods.showGameCoinPrice && salePriceDisplay ? 'inline-block' : 'none'
        }"
      ></i>
      <!-- salePriceDisplay为0时不展示点券icon-->
      {{ salePriceDisplay }}
    </span>
    <span v-if="goods.saleChannelPrice" class="active-cost--txt">{{ goods.unit }}</span>
    <span v-show="goods.totalPrice" class="active-cost--old">{{ totalPriceDisplay }}</span>
  </p>
</template>
<script>
export default {
  props: ["goods", "gameCoinIcon"],
  computed: {
    salePriceDisplay() {
      if (this.goods.saleChannelPrice) {
        return `${this.goods.saleChannelPrice}`
      } else if (this.goods.showGameCoinPrice) {
        return this.goods.salePrice
      } else {
        // 兼容价格为0，如果价格为0或空，则不显示￥
        return this.goods.saleCashRMBPrice ? `￥${this.goods.saleCashRMBPrice}` : ""
      }
    },
    totalPriceDisplay() {
      if (this.goods.totalPrice) {
        if (this.goods.totalChannelPrice) {
          return `${this.goods.totalChannelPrice}${this.goods.unit}`
        } else if (this.goods.showGameCoinPrice) {
          return `${this.goods.totalPrice}${this.goods.unit}`
        } else {
          return `￥${this.goods.totalCashRMBPrice}`
        }
      } else {
        return ""
      }
    }
  }
}
</script>
